export class JobStatusDetail {
  public id?: string;
  public name?: string;
  public progress = 0;
  public status?: JobStatus;
  public errorNote?: any;
  public isDownloaded?: boolean;
  public ValidationFailed = 0;
  public NoChanges = 0;
  public Created = 0;
  public Updated = 0;
  public SaveFailed = 0;
}
export enum JobType {
  UploadCustomLimitSets = 0,
  DownloadCustomLimitSets = 1,
  BulkSaveGroups = 2,
  DownloadGroups = 3
}

export enum JobStatus {
  New = 'New',
  Failed = 'Failed',
  Active = 'Active',
  Ready = 'Ready',
  Completed = 'Completed',
  Partially = 'Partially Completed'
}

export class JobStatusProcessing {
  public id?: string;
  public status?: string;

  constructor(data?: { id?: string; status?: string }) {
    if (data) {
      this.id = data.id;
      this.status = data.status;
    }
  }
}
